<template>
  <div id="transhipmentsNegotitations">
    <BreadCrumb :items="breadcrumbItems" />

    <v-card elevation="1" class="pt-5 mt-1">
      <div class="d-flex justify-space-between px-5 align-center">
        <h1>Negociações de Transbordo</h1>
        <v-btn @click="openNewNegotiationDialog" elevation="2" color="success" large>NOVA NEGOCIAÇÃO</v-btn>
      </div>
      <div class="table mt-10">
        <v-data-table
          :headers="headers"
          :items="getNegotiations"
          :loading="loading"
          :items-per-page="paginate.pageSize"
          @update:items-per-page="changeItemsPerPage"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 50],
            itemsPerPageText: 'Itens por página'
          }"
        >
          <template v-slot:[`item.isCompany`]="{ item }">
            <v-chip v-if="item.isCompany" color="success"> Empresa </v-chip>
            <v-chip v-else color="info"> Pessoal </v-chip>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex align-center">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <PencilSVG @click="openEditNegotiation(item)" v-bind="attrs" v-on="on" />
                </template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <ViewSVG @click="selectTranshipment(item)" v-bind="attrs" v-on="on" class="mx-3" />
                </template>
                <span>Ver Tarifas</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <TrashSVG @click="handleNegociationDelete(item.id)" role="button" v-bind="attrs" v-on="on" />
                </template>
                <span>Deletar</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
      </div>
    </v-card>
    <delete-confirm-dialog
      :isOpen.sync="isDeleteDialogOpen"
      @confirmClick="onDeleteNegotiationConfirm"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      title="Deletar Negociação"
      body-text="Você confirma estar deletando esta negociação?"
    />
    <transhipment-negociation-dialog
      :isOpen.sync="isDialogOpen"
      :negociationToEdit="negociationToEdit"
      @shouldRefresh="fetchAllNegotiations"
    />
    <MessagesError :errors="errors" @closeMessages="errors = []" :type="errorsType" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import BreadCrumb from '../../../components/BreadCrumb.vue';
import TranshipmentNegociationDialog from '@/components/Transhipment/TranshipmentNegociationDialog.vue';
import DeleteConfirmDialog from '@/components/ConfirmDialog';
import MessagesError from '@/components/MessagesError.vue';

// SVGs
import ViewSVG from '@/assets/img/view.svg';
import TrashSVG from '@/assets/img/trash.svg';
import PencilSVG from '@/assets/img/pencil.svg';
export default {
  name: 'TranshipmentNegotiations',
  components: {
    BreadCrumb,
    ViewSVG,
    TrashSVG,
    PencilSVG,
    TranshipmentNegociationDialog,
    DeleteConfirmDialog,
    MessagesError
  },
  data: () => ({
    errors: [],
    errorsType: 'success',
    negociationIdToDelete: null,
    isDeleteButtonLoading: false,
    isDeleteDialogOpen: false,
    negociationToEdit: null,
    pageNumber: 1,
    totalPages: 0,
    isDialogOpen: false,
    loading: true,
    negotiations: [],
    breadcrumbItems: [
      {
        text: 'Início',
        disabled: false,
        to: '/start'
      },
      {
        text: 'Transbordos',
        disabled: false,
        to: '/transhipments/',
        exact: true
      },
      {
        text: 'Negociações',
        disabled: true
      }
    ],
    headers: [
      { text: 'HIERARQUIA', value: 'typeNegotiation' },
      { text: 'TIPO DE NEGOCIAÇÃO', value: 'subTypeNegotiation' },
      { text: 'NOME', value: 'name', align: 'start' },
      { text: 'CIDADE', value: 'city' },
      { text: 'TIPO DE TRANSBORDO', value: 'isCompany' },
      { text: 'AÇÕES', value: 'actions' }
    ]
  }),
  computed: {
    ...mapState('TranshipmentStore', ['paginate']),
    ...mapGetters('TranshipmentStore', ['getTranshipments', 'getNegotiations']),

    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);

        this.fetchAllNegotiations();
      }
    },
    desserts() {
      return this.getTranshipments;
    }
  },
  created() {
    this.setItemPerPage(10);
    this.fetchAllNegotiations();
  },

  methods: {
    ...mapMutations('TranshipmentStore', [
      'setPageNumber',
      'setItemPerPage',
      'trashTranshipment',
      'toggleDisableTranshipment',
      'setTranshipmentSelectedName'
    ]),
    ...mapActions('TranshipmentStore', [
      'fetchTranshipment',
      'fetchTranshipmentNegotiationCNPJByID',
      'fetchTranshipmentNegotiationCityByID',
      'fetchNegotiations',
      'deleteNegotiation'
    ]),
    selectTranshipment(item) {
      this.setTranshipmentSelectedName(item.name);

      this.$router.push(`/transhipments/negotiations/${item.id}`);
    },

    async fetchAllNegotiations() {
      this.loading = true;
      try {
        await this.fetchNegotiations();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async onDeleteNegotiationConfirm() {
      try {
        this.isDeleteButtonLoading = true;
        const { success, errors } = await this.deleteNegotiation(this.negociationIdToDelete);

        if (success) {
          this.errors = ['Negociação deletada com sucesso!'];
          this.errorsType = 'success';
        } else {
          this.errors = errors;
          this.errorsType = 'error';
        }

        await this.fetchAllNegotiations();
        this.isDeleteDialogOpen = false;
      } catch (error) {
        console.error(error);
      } finally {
        this.isDeleteButtonLoading = false;
      }
    },

    async fetchAllTranshipment() {
      this.loading = true;
      try {
        await this.fetchTranshipment();
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    handleNegociationDelete(negociationIdToDelete) {
      this.negociationIdToDelete = negociationIdToDelete;
      this.isDeleteDialogOpen = true;
    },
    openNewNegotiationDialog() {
      this.isDialogOpen = true;
      this.negociationToEdit = null;
    },
    openEditNegotiation({ id, name, typeNegotiation, subTypeNegotiation }) {
      this.isDialogOpen = true;
      this.negociationToEdit = { id, name, typeNegotiation, subTypeNegotiation };
    },
    changeItemsPerPage(items) {
      this.setItemPerPage(items);

      this.fetchAllNegotiations();
    }
  }
};
</script>

<style lang="scss"></style>
